import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject, signal } from '@angular/core';
import { BehaviorSubject, catchError, map, Observable, of, shareReplay, take } from 'rxjs';
import { toSignal } from '@angular/core/rxjs-interop';
import { API_URL } from '../utils/injection-tokens/api-url.token';
import {
  PDropdownOptions,
  User,
  UserDto,
  UserRole,
  CreateUser,
  UpdateUserDto,
} from '../interfaces';
import { Roles } from '../utils';
import { UserHttpService } from './users-http.service';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  
  private userHttpService =inject(UserHttpService)
  private apiUrl = inject(API_URL) + 'users';

  private caseManagerOptions$ = this.userHttpService.getUsersV1(Roles.CaseManager).pipe(
    map((users) => this.toPDropdownOption(users)),
    shareReplay(1)
  );

  caseManagerOptions = signal<PDropdownOptions[]>([]);

  loadCaseManagerOptions(): void {
    this.caseManagerOptions$.pipe(take(1)).subscribe((options) => {
      this.caseManagerOptions.set(options);
    });
  }

  investigatorOptions = toSignal(this.userHttpService.getUsersV1(Roles.Investigator).pipe(
    map((users) => {
      return this.toPDropdownOption(users);
    })
  ), { initialValue: [] });


  private toPDropdownOption(users: User[]): PDropdownOptions[] {
    return users.map((user) => ({
      label: `${user.firstName} ${user.lastName}`,
      value: user.userId,
    }));
  }
}
